import { Component } from '@angular/core';

@Component({
  selector: 'app-hearing',
  templateUrl: './hearing.component.html',
  styleUrls: ['./hearing.component.scss']
})
export class HearingComponent {

}
